import BaseService from './BaseService'
import * as apiroutes from '../apiRoutes'

class CaseCloseService extends BaseService {
    constructor() {
        super(apiroutes.CASE_CLOSE_REASONS)
    }

 
    async create(data) {
        return await super.customCall('POST', '', data, null, 'json');
    }

    async update(id, data) {
        return await super.customCall("PATCH", `/${id}`, data, null, "json")
    }
    
    async delete(id) {
        return await super.delete(id)
    }

    async get(params = {}) {
        return await super.getAll(params)
    }

    async getOfficerCounts(params = {}) {
        return await super.customCall(
            "GET",
            "/officer-counts",
            null,
            params,
            null
        );
    }
    async getAll(params = {}) {
        return await super.customCall("GET", '', null, params, null)
    }

    async getImage(id) {
        return await super.customCall("GET", `/${id}/logo`, null, null, null)
    }

    async getFromPost(params = {}) {
        return await super.getByPost(params)
    }

    async getById(id) {
        return await super.getById(id)
    }

    async search(searchTerm, filters = {}) {
        return await super.search(searchTerm, filters)
    }

    async bulkUpdate(ids, updateData) {
        return await super.bulkUpdate(ids, updateData)
    }

    async bulkDelete(ids) {
        return await super.bulkDelete(ids)
    }

    async export(format = 'csv', filters = {}) {
        return await super.export(format, filters)
    }

    async updateStatus(id, data) {
        return await super.updateStatusByPut(id, data)

    }
   
}

// Create instance and export it
const CaseCloseServices = new CaseCloseService()
export default CaseCloseServices